export const globalConfig = {
  // The format to use when displaying timestamps
  dateTimeFormat: 'EE, do MMM yyyy • h:mm:ss a',
  fullDateFormat: 'EE, do MMM yyyy',
  dateFormat: 'Do MMM yyyy',
  timeFormat: 'HH:mm:ss a',

  // Currency related settings
  currency: {
    // The currency code to use when formatting prices
    code: 'LKR',

    // The currency symbol to use when formatting prices
    symbol: 'Rs.',

    // The number of decimal places to use when formatting prices
    digits: 2,

    // The locale to use when formatting prices
    locale: 'en-US',
  },
}

export const i18n = {
  defaultLocale: 'en',
  locales: ['en', 'si', 'ta'],
} as const

export type Locale = (typeof i18n)['locales'][number]

export const paymentMethods = [
  'card',
  'cash',
  'pickme',
  'uber',
  'other',
] as const
